import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "msi-upload" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选取文件")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("上传导入")

import {  ref,computed} from "vue";
import ElUpload from "element-plus/lib/el-upload";
import {useStore} from '@/store'
import {ElMessage } from "element-plus";
import local from '@/utils/cache'

export default /*#__PURE__*/_defineComponent({
  props: {
    apiUrl: null
  },
  setup(__props: any) {

const props = __props as {apiUrl: string}



const store = useStore();
//文件上传的地址
const actionUrl = computed(() => local.getCache('host')=='192.168.150.23'?'http://192.168.150.23:9085/api':'http://222.71.245.114:9085/api' + props.apiUrl)
//headers
const token = computed(() => store.state.login.token)

const headerObj = ref({
  Authorization: `Bearer ${token.value}`
});
const uploadRef = ref<InstanceType<typeof ElUpload>>();

const fileList = ref<any>([]);

const submitUpload = () => {
  uploadRef.value!.submit();
};
const handleRemove = (file: any, fileList: any) => {
  // console.log('移除成功')
};
const handleSuccess = (response: any, file: any) => {
  if(response.code == 200) {
    fileList.value = [];
    ElMessage.success('导入成功')
  }else {
    ElMessage.error(`导入失败${response.code}:${response.message}`)
  }

};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElUpload), {
      class: "upload-demo",
      ref_key: "uploadRef",
      ref: uploadRef,
      headers: headerObj.value,
      limit: 4000,
      action: _unref(actionUrl),
      "on-success": handleSuccess,
      "on-remove": handleRemove,
      "file-list": fileList.value,
      "auto-upload": false,
      accept: ".xls,.xlsx"
    }, {
      trigger: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          style: {"margin-left":"10px"},
          size: "small",
          type: "success",
          onClick: submitUpload
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["headers", "action", "file-list"])
  ]))
}
}

})